<template>
<div class="chapter">
<div class="inner_page">
<p class="FMH">A NOTE ON SPELLING</p>
<p class="FMTNI">Although current usage calls for Catalan or Basque spelling for proper and place names in those regions, I have followed contemporary (1930s) practice in rendering them in Castilian Spanish—or, in a few cases where contemporary sources did likewise, in anglicized orthography. Thus today’s Lleida becomes Lérida; Gernika becomes Guernica; Andreu Nin becomes Andrés Nin; but the Catalan Catalunya becomes the anglicized Catalonia (not the Castilian Cataluña), and the Castilian Zaragoza becomes Saragossa. However, the state government of Catalonia is referred to as the Generalitat (not Generalidad), since that is the how both Arturo Barea and John Dos Passos refer to it. Also, when writing of Robert Capa’s assignment in China, I’ve given his location as Hankow (as it was spelled at the time).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// anoteonspelling.vue?4b252ff5